var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_c('label',[_vm._v("Fecha de firma*")])]),_c('b-col',{attrs:{"md":"8"}},[_c('b-form-datepicker',{attrs:{"locale":"es-ES","disabled":_vm.disabled,"min":_vm.fechaOferta,"start-weekday":1},model:{value:(_vm.fechaFirma),callback:function ($$v) {_vm.fechaFirma=$$v},expression:"fechaFirma"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }